/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { css, keyframes } from 'fierry/react';


const pulseFrames = keyframes`
  0%, 100% { stroke-opacity: 1.0; }
  50%      { stroke-opacity: 0.5; }
`;


export const pulse = ({ pulse }) => pulse && css`
  animation: ${pulseFrames} 2.5s ease-in-out infinite;
`;


export const glow = ({ glow, hexGeometry }) => glow && css`
  filter: drop-shadow(0 0 ${hexGeometry.getExternalSize() / 6}px var(--accent-11));
`;
